import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import SyncedCollectionsListHeader from './ListHeader';
import SyncedCollectionsListItem from './ListItem';

import EmptySyncedCollections from '../../containers/EmptyContainers/SyncedCollections';

const SyncedCollectionsList = ({
  collections,
  loadSyncedCollections,
  ...props
}) => (
  <>
    {collections.length > 0 ? (
      <div className="table-wrapper">
        <Table className="users-list synced-collections-list files-list" responsive>
          <thead>
            <SyncedCollectionsListHeader
              {...props}
            />
          </thead>
          <tbody>
            {collections.map(collection => (
              <SyncedCollectionsListItem
                key={collection.uuid}
                collection={collection}
                loadSyncedCollections={loadSyncedCollections}
              />
            ))}
          </tbody>
        </Table>
      </div>
    ) : (
      <EmptySyncedCollections />
    )}
  </>
);

SyncedCollectionsList.propTypes = {
  collections: PropTypes.array.isRequired,
  loadSyncedCollections: PropTypes.func.isRequired,
};

export default SyncedCollectionsList;
